module.exports = __webpack_public_path__ + "images/social-media-kit-1-d6e47c78188dcdb2023e12407028303e.jpg";